<template>
  <PasswordManager />
</template>

<script>
import PasswordManager from './components/PasswordManager.vue'

export default {
  name: 'App',
  components: {
    PasswordManager
  }
}
</script>

<style>
/* 全局样式将在PasswordManager组件中定义 */
</style>
